import { DoubleArrow } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../redux/types'
import TypeFilter from '../../../../shared/components/TypeFilter'
import HiddenDesktop from '../../../../shared/styles/HiddenDesktop'
import ScrollSubHeader from '../../../../shared/styles/ScrollSubHeader'

interface IRoleMenuFilterProps {
  filters: any
  handleChangeFilter: any
}

export function RoleMenuFilter({ filters, handleChangeFilter }: IRoleMenuFilterProps) {
  const { t } = useTranslation(['global'])

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { roles, rolehierarchy } = useSelector((state: IRootState) => state.role)

  const handleRoleOptions = (role_id: number) => {
    const childRoles = roles.filter((role: any) => role_id === role.parent_id)
    let filterExtraRoleOptions: any

    // Remove pending VIPs for commercials
    if ([4, 8, 9].includes(authUser.role_id))
      filterExtraRoleOptions = extraRoleOptions[role_id].filter((roleOption: any) => roleOption.id !== 4)
    else filterExtraRoleOptions = extraRoleOptions[role_id]

    return childRoles.concat(filterExtraRoleOptions)
  }

  let extraRoleOptions: any = []
  extraRoleOptions[2] = []
  extraRoleOptions[3] = []
  extraRoleOptions[4] = [{ id: 4, name: t('admin.people.pending-vip') }]
  extraRoleOptions[5] = []
  extraRoleOptions[6] = [
    { id: 1, name: t('admin.people.verified') },
    { id: 0, name: t('admin.people.pending') },
    { id: 3, name: t('admin.people.denied') },
    { id: 4, name: t('admin.people.pending-vip') }
  ]
  extraRoleOptions[7] = [{ id: 4, name: t('admin.people.pending-vip') }]
  const myElement: HTMLElement | null = document.getElementById('windowCourseClient')
  const midOfWidth = window.innerWidth / 2

  return (
    <>
      <ScrollSubHeader className="usersHeader" id="windowCourseClient">
        {roles
          .filter((role: any) => rolehierarchy.includes(role.id) && [2, 3, 4, 5, 6, 7].includes(role.id))
          .map((role: any) => (
            <TypeFilter
              key={role.id}
              id={role.id}
              type={role.name}
              categories={handleRoleOptions(role.id)}
              active={role.id === filters.header_role_id}
              filterCategoryId={filters.subheader_role_id}
              handleChangeFilter={handleChangeFilter}
            />
          ))}
      </ScrollSubHeader>
      <HiddenDesktop>
          <IconButton
            sx={{ position: 'absolute', right: 0, top:'17%', zIndex: 10, backgroundColor: 'white' }}
            className="buttonScroll"
            onClick={() => {
              myElement?.scrollBy(midOfWidth, 0)
            }}
          >
          <DoubleArrow />
        </IconButton>
      </HiddenDesktop>
    </>
  )
}
